<template>
    <div class="status-block content-block" :class="rootClasses">
        <div class="container">
            <div class="status-title">
                {{ data.title }}
            </div>
            <div class="status-text" v-html="data.text">
            </div>
            <div class="row">
                <div class="col-12 col-md-8">
                    <div class="systems-list">
                        <div id="accordion">
                            <div class="card" v-for="(card, key) in dataStatus" :key="key">
                                <button class="card-header collapsed" :id="`headingTwo${key}`" data-toggle="collapse"
                                    :data-target="`#collapseTwo${key}`" aria-expanded="false"
                                    :aria-controls="`collapseTwo${key}`">
                                    <div class="left">
                                        <div class="card-title">
                                            {{ card.title }}
                                        </div>
                                        <div class="card-label info-btn first-i" :title="card.text">i</div>
                                        <div class="card-label sec-hide">{{ labels.hide }}</div>
                                    </div>

                                    <div class="card-label" :style="`background: linear-gradient(90deg,  ${systemKey(key).color}  35%,  ${systemKey(key).color}aa 100%);`">
                                        {{ systemKey(key).name }}
                                    </div>
                                </button>
                                <div :id="`collapseTwo${key}`" class="collapse" :aria-labelledby="`headingTwo${key}`"
                                    data-parent="#accordion">
                                    <div class="card-body" v-html="card.description">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="actions">
                        <div class="action" :class="{ line: key < allStatus.length - 1 }" v-for="(action, key) in allStatus"
                            :key="key">
                            <div class="action-header">
                                <div class="left">
                                    <div class="action-title">
                                        {{ action.title }}
                                    </div>
                                    <div class="action-key" :style="`background: linear-gradient(90deg,  ${actionKey(action.key).color}  35%, ${actionKey(action.key).color}aa 100%);`">
                                        {{ actionKey(action.key).name }}
                                    </div>
                                </div>
                                <div class="action-label">
                                    {{ action.system }}
                                </div>
                            </div>
                            <div class="action-text">
                                {{ action.text }}
                            </div>
                            <div class="action-date">
                                <div class="action-year">
                                    {{ toYear(action.date) }}
                                </div>
                                <div class="action-hour">
                                    {{ toHour(action.date) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="keys">
                        <div class="keys-title">
                            {{ labels.status_keys }}
                        </div>
                        <div class="key" v-for="(key, idx) in allKeys" :key="idx">
                            <div class="key-label" :style="`background: linear-gradient(90deg,  ${key.color}  35%, ${key.color}aa 100%);`">
                                {{ key.name }}
                            </div>
                            <div class="key-text">
                                {{ key.description }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Status',
    data() {
        return {
            allStatus: [],
            dataStatus: [],
            labels: {
                status_keys: 'Status keys',
                status_page_system: 'Status page system',
                hide: "Hide"
            }
        }
    },

    props: {
        data: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        rootClasses() {
            let result = {
                ['cs-status']: true,
                ['has-background']: true,
                ['theme-block']: true,
            }

            if (this.data?.hasBackground)
                result = {
                    ...result,
                    ...{
                        ['theme-bg-colored']: true
                    }
                }

            return result
        },
        allKeys() {
            let keys = []
            this.dataStatus.forEach(status => {
                status.keys.forEach(key => {
                    if (keys.length == 0) keys.push(key)

                    else {
                        if (!keys.some(obj => obj.slug === key.slug)) {
                            keys.push(key)
                        }
                    }
                })
            })
            return keys
        },

    },
    mounted() {
        this.data.statusList.forEach(status => {
            status.tags.forEach(tag => {
                this.data.statusTags.forEach(sTag => {
                    if (tag.slug == sTag.slug) {
                        if (!this.dataStatus.some(obj => obj.title === status.title)) {
                            this.dataStatus.push(status)
                        }
                    }
                })
            })
        })

        this.dataStatus.forEach(status => {
            status.status.forEach(stat => {
                stat.system = status.title
                this.allStatus.push(stat)
            })
        })
    },
    methods: {
        toYear(dateStr) {
            const dateObj = new Date(dateStr)
            const options = {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            }
            let formattedDate = dateObj.toLocaleDateString('en-GB', options)
            formattedDate = formattedDate.replace(/\//g, '.')
            return formattedDate
        },
        toHour(dateStr) {
            const timeStr = dateStr.substr(11, 5)
            return timeStr
        },
        systemKey(index) {
            let status = this.dataStatus[index]

            let keys = status.keys

            let response

            if (keys.length) {
                this.allKeys.forEach(key => {
                    if (key.slug == keys[0].slug) {
                        response = key
                    }
                })
            } else {
                response = 'not yet'
            }

            return response
        },
        actionKey(slug) {
            let response = 'not yet';
            this.allKeys.forEach(key => {
                if (key.name === slug) {
                    response = key;
                }
            });
            return response;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/main.scss';

.status-block {
    background-color: $text_color_over_theme_color
}

.status-title {
    @include title;
    text-align: center;
    margin-bottom: $block_space_sm;
}

.status-text {
    @include text;
    max-width: 990px;
    text-align: center;
    margin: auto;
    margin-bottom: $block_space_sm;
}

.systems-list {
    #accordion {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .card {
            border: none;
            border-radius: 15px;
            overflow: hidden;
            .collapsed {
                .sec-hide {
                    display: none;
                }

                .info-btn {
                    display: flex;
                    color: #fff !important;
                }
            }

            &-header {
                display: flex;
                background: #e4eef7;
                justify-content: space-between;
                align-items: center;
                // border-radius: 15px;
                border: none;
                .info-btn{
                    display: none;
                    padding: 1px 10px !important;
                }
                .left {
                    display: flex;
                    align-items: center;
                    gap: 10px;

                    .card-title {
                        margin: 0;
                        font-weight: $theme_bold_text;
                    }

                    button {
                        line-height: 1;
                        padding: 0;
                        background-color: #fcbd01;
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        color: $text_color_over_theme_color;
                    }
                }

                .card-label {
                    padding: 5px 15px;
                    color: $primary_text_color;
                    font-size: $regular_text_size;
                    border-radius: 35px;
                    background-image: linear-gradient(to right top, #ffe0b9, #ffd69c, #ffcc7f, #ffc260, #ffb83f);
                }
            }

            &-body {
                // border-bottom-left-radius: 15px;
                // border-bottom-right-radius: 15px;
                background: #e4eef7;
                font-size: $regular_text_size;
            }
        }
    }
}

.actions {
    padding-left: 20px;

    .line {
        position: relative;

        &::after {
            position: absolute;
            content: '';
            width: 1px;
            left: -13px;
            top: 17px;
            height: 112%;
            background-color: $labels_color;
        }
    }

    .action {
        margin: 25px 0;
        position: relative;

        &::before {
            position: absolute;
            content: '';
            width: 10px;
            left: -18px;
            top: 7px;
            height: 10px;
            border-radius: 50%;
            border: 2px solid $theme_color;
        }

        &-header {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .left {
                display: flex;
                gap: 10px;
                justify-content: center;
                align-items: center;
            }

            .action-title {
                font-weight: $theme_bold_text;
            }

            .action-key {
                border-radius: 35px;
                background-image: linear-gradient(to right top, #ffe0b9, #ffd69c, #ffcc7f, #ffc260, #ffb83f);
                padding: 5px 15px;
                color: $primary_text_color;
                font-size: 12px;
                font-weight: 500;
            }

            .action-label {
                font-size: 13px;
                color: $theme_color;
                font-weight: $theme_bold_text;
            }
        }

        &-text {
            font-size: 13px;
            margin: 15px 0 10px 0;
        }

        &-date {
            display: flex;
            justify-content: space-between;
            font-size: 13px;
            color: $labels_color;
        }
    }
}

.keys {
    padding: 15px;

    &-title {
        font-weight: $theme_bold_text;
        font-size: 20px;
        padding-bottom: 10px;
    }

    .key {
        margin: 7px 0;
        padding: 15px;
        border-radius: 15px;
        background: #e4eef7;

        &-label {
            display: inline-block;
            background: linear-gradient(90deg, rgba(5, 174, 131, 1) 35%, rgba(41, 213, 132, 1) 100%);
            padding: 5px 15px;
            color: #fff;
            border-radius: 35px;
            font-size: 12px;
            font-weight: 500;
        }

        &-text {
            padding: 7px 0;
            font-size: 13px;
        }
    }
}</style>
